import Vue from 'vue'

Vue.filter("reverse", (value) => {
	// slice to make a copy of array, then reverse the copy
	return value.slice().reverse();
});